import React from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  CheckboxController,
  RichController,
  TextController,
} from "@pushpress/shared-components";
import PanelModal from "../PanelModal";

export interface SendEmailForm {
  subject: string;
  message: string;
  bccYourself: boolean;
  bccStaff: boolean;
  bccAdmins: boolean;
}

export interface SendEmailModalProps {
  title: string;
  message?: string;
  loading?: boolean;
  visible: boolean;
  onClose: VoidFunction;
  onSendClick: (values: SendEmailForm) => void;
}

function SendEmailModal(props: SendEmailModalProps) {
  const { visible, onClose } = props;

  return (
    <PanelModal visible={visible} onClose={onClose}>
      <SendEmailModalContent {...props} />
    </PanelModal>
  );
}

function SendEmailModalContent(props: SendEmailModalProps) {
  const { title, message, onSendClick, loading } = props;

  const { control, handleSubmit } = useForm<SendEmailForm>();

  return (
    <form onSubmit={handleSubmit(onSendClick)}>
      <PanelModal.Header title={title} />
      <PanelModal.Body message={message}>
        <TextController
          label="Subject"
          control={control}
          name="subject"
          required
        />
        <RichController
          label="Message"
          control={control}
          name="message"
          required
          height="200px"
          valueType="html"
          multiLineToolbarPosition="bottom"
        />
        <CheckboxController
          control={control}
          name="bccYourself"
          label="Bcc yourself"
          className="mb-3"
        />
        <CheckboxController
          control={control}
          name="bccStaff"
          label="Bcc staff"
          className="mb-3"
        />
        <CheckboxController
          control={control}
          name="bccAdmins"
          label="Bcc admins"
        />
      </PanelModal.Body>
      <PanelModal.Footer>
        <Button
          text="Send"
          buttonType="primary"
          loading={loading}
          type="submit"
        />
      </PanelModal.Footer>
    </form>
  );
}

export default SendEmailModal;
